module.exports = __webpack_public_path__ + "media/images/new_search_grey-09e3d2c95e61015e56423275d7e79c9a.svg";